import { createSlice } from "@reduxjs/toolkit";


interface IInputState {
  isCategoryEditInputFocused: boolean;
  isSpecificationNameEditInputFocused: boolean;
}

const initialState: IInputState = {
  isCategoryEditInputFocused: false,
  isSpecificationNameEditInputFocused: false
};

export const inputSlice = createSlice({
  name: "input",
  initialState,
  reducers: {
    setIsCategoryEditInputFocused: (state, action) => {
      state.isCategoryEditInputFocused = action.payload;
    },
    setIsSpecificationNameEditInputFocused: (state, action) => {
      state.isSpecificationNameEditInputFocused = action.payload;
    }
  }   
});

export const { setIsCategoryEditInputFocused, setIsSpecificationNameEditInputFocused } = inputSlice.actions;
export default inputSlice.reducer;
